import { render } from "./class.vue?vue&type=template&id=4e92b5c0&scoped=true"
import script from "./class.vue?vue&type=script&lang=js"
export * from "./class.vue?vue&type=script&lang=js"

import "./class.vue?vue&type=style&index=0&id=4e92b5c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e92b5c0"]])

export default __exports__